import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { TaskDetailReportTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { TaskDetailReportschemaObject } from "../TaskDetailReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import MaterialTable from "material-table";
import moment from 'moment';

const screenCode = "TASKDETAILREPORT";

export function TaskDetailReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [gtnnumber, setGtnnumber] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [taskCategory, setTaskCategory] = useState();
    const [labourTask, setLabourTask] = useState();

    const [taskDetailReport, setTaskDetailReport] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        month: "",
        searchDate: "",
        category: "0",
        task: "0"
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        month: "",
        searchDate: "",
        category: "0",
        task: "0"
    })
    const [csvData, setCsvData] = useState([]);

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(TaskDetailReportschemaObject).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName", "firstName", "employeeTypeName", "registrationNumber", "fieldName", "createdDate", "progress", "startTime", "endTime"]
    const csvHeaders = [
        { label: "Division", value: "collectionPointName" },
        { label: "Emp Name", value: "firstName" },
        { label: "Emp Type", value: "employeeTypeName" },
        { label: "Reg No", value: "registrationNumber" },
        { label: "Field", value: "fieldName" },
        { label: "Date", value: "createdDate" },
        { label: "Percentage (%)", value: "progress" },
        { label: "Start Time", value: "startTime" },
        { label: "End Time", value: "endTime" }
    ];

    const [reportData, setReportData] = useState([]);
    const [reportDataOne, setReportDataOne] = useState([]);
    const [keys, setKeys] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [taskDetailReport.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
            getTaskNames(),
            getLabourTask()

        )
    }, [taskDetailReport.estateID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
            getLabourTask()

        )
    }, [taskDetailReport.category])


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setTaskDetailReport({
            ...taskDetailReport,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"

        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setTaskDetailReport({
            ...taskDetailReport,
            estateID: target.value,
            divisionID: "0"

        });
    }

    function handleDivisionChange(target) {
        setTaskDetailReport({
            ...taskDetailReport,
            divisionID: target.value

        });
    }


    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, TaskDetailReportschemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWTASKDETAILREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setTaskDetailReport({
            ...taskDetailReport,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(taskDetailReport.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(taskDetailReport.estateID);
        setDivisions(data);
    }

    async function getTaskNames() {
        const result = await services.getAllTaskNames(taskDetailReport.groupID, taskDetailReport.estateID);
        setTaskCategory(result);
    }

    async function getLabourTask() {
        const result = await services.getLabourTaskByOperationEntityIDTaskCategoryID(taskDetailReport.estateID)
        setLabourTask(result)
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target;

        const value = target.type === "checkbox" ? target.checked : target.value;
        setTaskDetailReport({
            ...taskDetailReport,
            [e.target.name]: value,
        });
    }

    async function handleSearch(e) {

        getSelectedDropdownValuesForReport(taskDetailReport);

        setIsTableHide(true);

        const result = await services.getTaskDetailReportDetails(taskDetailReport);
        let groupedResult = groupByGtn(result);
        let keys = Object.keys(groupedResult);

        setKeys(keys);
        setReportData(result);
        setReportDataOne(groupedResult);

        if (result.length > 0) {
            result.forEach(x => {
                x.createdDate = x.createdDate.split('T')[0]; 
                x.startTime = moment(x.startTime).format('h:mm:ss a');
                x.endTime = moment(x.endTime).format('h:mm:ss a');
            })
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }


        setButtonHide(false);
        setIsReportButtonsEnabled();

        const comlpeteData = [...result];
        setCsvData(comlpeteData)
    }

    function createFile() {
        var settings = {
            sheetName: 'Task Detail Report',
            fileName: 'TaskDetailReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            collectionPointName: "Group :" + groups[taskDetailReport.groupID],
            firstName: "Operation Entity : " + estates[taskDetailReport.estateID],
            employeeTypeName: "Date : " + taskDetailReport.month,
            registrationNumber: "Generated date/time : " + new Date().toLocaleString(),
            fieldName: "Generated user : " + tokenService.getUserNameFromToken()
        }
        copyOfCsv.push({}, {}, newRow1)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            category: searchForm.category,
            task: searchForm.task,
            month: searchForm.month
        })
    }

    function groupByGtn(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['gtnNumber']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Task Detail Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={taskDetailReport.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={taskDetailReport.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Collection Point </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={taskDetailReport.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="category">Category *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="category"
                                            name="category"
                                            value={taskDetailReport.category}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Task Category--</MenuItem>
                                            {generateDropDownMenu(taskCategory)}
                                        </Select>
                                        {errors["category"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["category"]}</FormHelperText>}

                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="sundryTask">Task *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="task"
                                            name="task"
                                            value={taskDetailReport.task}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Task--</MenuItem>
                                            {generateDropDownMenu(labourTask)}
                                        </Select>
                                        {errors["task"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["task"]}</FormHelperText>}

                                    </div>

                                    <div className="col-md pb-1">
                                        <TextField
                                            id="month"
                                            label="Month *"
                                            name="month"
                                            type="month"
                                            fullWidth
                                            value={taskDetailReport.month}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["month"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>

                            {isTableHide ? null :
                                <div>
                                    <MaterialTable
                                        title="Multiple Actions Preview"
                                        columns={[
                                            { title: 'Collection Point', field: 'collectionPointName', headerStyle: { fontWeight: "bold" } },
                                            { title: 'Emp Name', field: 'firstName', headerStyle: { fontWeight: "bold" } },
                                            { title: 'Emp Type', field: 'employeeTypeName', headerStyle: { fontWeight: "bold" } },
                                            { title: 'Reg No', field: 'registrationNumber', headerStyle: { fontWeight: "bold" } },
                                            { title: 'Field', field: 'fieldName', headerStyle: { fontWeight: "bold" }, lookup: {
                                                    null: "-" }
                                            },
                                            { title: 'Category', field: 'estateTaskName', headerStyle: { fontWeight: "bold" } },
                                            { title: 'Task ', field: 'taskName', headerStyle: { fontWeight: "bold" } },
                                            { title: 'Percentage (%)', field: 'progress', headerStyle: { fontWeight: "bold" } },
                                            { title: 'Start Time', field: 'startTime', headerStyle: { fontWeight: "bold" } },
                                            { title: 'End Time', field: 'endTime', headerStyle: { fontWeight: "bold" } }
                                            
                                        ]}
                                        data={reportData}
                                        options={{
                                            exportButton: false,
                                            showTitle: false,
                                            headerStyle: { textAlign: "left", height: '1%' },
                                            cellStyle: { textAlign: "left" },
                                            columnResizable: false,
                                            actionsColumnIndex: -1
                                        }}
                                    />
                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                        <ReactToPrint
                                            documentTitle={"Task Detail Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} data={reportData} dataOne={reportDataOne}
                                            rowNames={contentRowNames} searchData={selectedSearchValues} keys={keys} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
